




















































import { Component, Prop, Vue } from "@/shared/node_modules/vue-property-decorator";
import TextArea from "@/shared/components/form/textArea.vue";
import { VideoSubmissionState, fmtSeconds, MaxVideoMinutes, MaxVideoGb } from "./videoSubmissionState";

@Component({ components: { TextArea } })
export default class SubmissionPanel extends Vue {
  @Prop() state!: VideoSubmissionState;
  @Prop() instructions!: string;
  @Prop({ default: false }) isComment!: boolean;

  fmtSeconds = fmtSeconds;
  maxMinutes = String(MaxVideoMinutes);
  maxGb = String(MaxVideoGb);

  triggerFileInput() {
    const input = this.$refs.fileInput as HTMLInputElement;
    if (input) input.click();
  }

  onFileSelected(e: Event) {
    const input = e.target as HTMLInputElement;
    if (input.files && input.files.length > 0) this.state.uploadVideo(input.files[0]);
  }
}
